export const getMyTimezoneId = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
